import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import { Flex } from '@radix-ui/themes'
import DriverCarForm, { DriverCarFormData } from './_form'
import SetupForEventCallout, { setupPath } from '@/shared/events/SetupForEventCallout'
import { DriverCarsNewProps } from '@/types/driver_cars'

export default function NewDriverCar({
  participant,
  color_families,
  aspirations,
  errors,
  event_id,
  event_name,
}: DriverCarsNewProps) {
  const { data, setData, post, processing } = useForm<DriverCarFormData>({
    participant,
    driver_car: {
      driver_name: '',
      make: '',
      model: '',
      chassis_code: '',
      year: null,
      trim: '',
      engine: '',
      aspiration: null,
      charger: '',
      hp: null,
      torque: null,
      color_family: '',
      body_kit: '',
      wheels: '',
      new_photos: []
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    post(setupPath('/driver_cars', { event_id, event_name }), { forceFormData: true })
  }

  return (
    <>
      <Head title="Add Car" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <Flex direction="column" gap="4">
          <SetupForEventCallout event_id={event_id} event_name={event_name} />
          <DriverCarForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            title="Add Car"
            submitLabel="Add Car"
            colorFamilies={color_families}
            aspirations={aspirations}
            photos={[]}
          />
        </Flex>
      </div>
    </>
  )
}
